$(function() {
    var new_item = "";
    $.ajax({
        url: "//www.kontatsu.co.jp/wp/wp-content/themes/kontatsu-child/assets/json/newitems.jsonp",
        type: "GET",
        dataType: "jsonp",
        jsonpCallback: "newitems",
        error: function() {},
        success: function(json) {
            for (var len = json.length, i = 0; i < len; i++) {
              if(json[i].category == "marche"){
                new_item = '';
              } else if (json[i].category == "beauty"){
                new_item = '';
              } else if (json[i].category == "softdrink"){
                new_item = '';
              } else {
                new_item = `
                <div class="newarrival-item">
                    <a href="https://www.saketora.com/products/${json[i].itemnum}">
                        <img src="${json[i].img}" alt="${json[i].name1}の商品画像" width="400" height="400" loading="lazy">
                        <p class="newarrival-item__name">${json[i].name1}</p>
                    </a>
                </div>
                `;
                $(".newarrival-items").append(new_item)
              }
            }
        }
    })
});